import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { AbstractRealityCheckDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractRealityCheckDialogProperties";
import { AbstractRealityCheckNoOptionsDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractRealityCheckNoOptionsDialogProperties";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import * as PIXI from "pixi.js";
export class RealityCheckDialogProperties extends AbstractRealityCheckDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties.id = CommonStyle.MESSAGE_DIALOG_0;
        this.titleFieldProperties.position.set(512, 120);
        this.titleFieldProperties.size = new PIXI.Point(800, 140);
        this.messageFieldProperties.position.set(512, 300);
        this.messageFieldProperties.size = new PIXI.Point(800, 240);
        this.messageFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.winFieldProperties.position.set(512, 496);
        this.winFieldProperties.size = new PIXI.Point(800, 70);
        this.wageredFieldProperties.position.set(512, 548);
        this.wageredFieldProperties.size = new PIXI.Point(800, 70);
        this.exitGameButtonProperties.position.set(205, 618);
        this.exitGameButtonProperties.textFieldProperties.size = new PIXI.Point(600, 100);
        this.exitGameButtonProperties.textFieldOffset.set(0, -8);
        this.wagerHistoryButtonProperties.position.set(205, 728);
        this.wagerHistoryButtonProperties.textFieldProperties.size = new PIXI.Point(600, 100);
        this.wagerHistoryButtonProperties.textFieldOffset.set(0, -8);
        this.continueButtonProperties.position.set(205, 840);
        this.continueButtonProperties.textFieldProperties.size = new PIXI.Point(600, 100);
        this.continueButtonProperties.textFieldOffset.set(0, -8);
    }
}
/**
 * RealityCheckNoOptionsDialogProperties.ts
 */
export class RealityCheckNoOptionsDialogProperties extends AbstractRealityCheckNoOptionsDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.titleFieldProperties.position.set(512, 284);
        this.titleFieldProperties.size = new PIXI.Point(800, 140);
        this.timeFieldProperties.position = new PIXI.Point(512, 412);
        this.timeFieldProperties.size = new PIXI.Point(800, 160);
        this.messageFieldProperties.position.set(512, 580);
        this.messageFieldProperties.size = new PIXI.Point(800, 240);
        this.messageFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.confirmButtonProperties.position = new PIXI.Point(206, 830);
        this.confirmButtonProperties.textFieldProperties.size = new PIXI.Point(400, 75);
    }
}
